







































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { Review, ReviewType } from "../../types";
import moment from "moment";

@Component({
  filters: {
    moment: (date: string) => {
      return moment(date).format("MM/DD/YYYY");
    }
  }
})
export default class ReviewSubmissions extends Vue {
  @Prop() private reviewType!: ReviewType;
  @Action private fetchReviewRequired!: () => any;
  @Action private fetchAlreadyReviewed!: () => any;
  @Getter private currentTeamID?: string;
  @Getter private sessionReviewRequired!: Review[];
  @Getter private sessionAlreadyReviewed!: Review[];

  private sessionList: Review[] = [];
  private reviewRequired: ReviewType = ReviewType.ReviewRequired;
  private tableHeaderColor = "#eafbff";
  private currentPage: number = 1;
  private totalRows: number = 0;
  private filter: string | null = null;
  private isLoading = true;
  private headVariant: string | null = null;
  private title: string | null = null;
  private reviewColumn: string | null = null;
  private sortBy: string = "";
  private sortDesc: boolean = true;
  private fields: any = [];

  private onFiltered(filteredItems: any[]) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }

  private rowClicked(item: Review) {
    if (this.currentTeamID) {
      let sessionReviewed = "false";
      if(item.reviewedOn && item.reviewedOn!==null) {

        sessionReviewed = "true";
      }

      this.$router.push({
        name: "reviewSession",
        params: {
          sessionReviewed,
          teamID: this.currentTeamID,
          sessionID: item.sid,
          learnerName: item.userName,
        }
      });
    }
  }

  @Watch("sessionReviewRequired")
  private onSessionReviewRequired() {
    if (this.reviewType === ReviewType.ReviewRequired) {
      this.isLoading = false;
      this.sessionList = this.sessionReviewRequired;
      if (this.sessionReviewRequired) {
        this.totalRows = this.sessionReviewRequired.length;
      } else {
        this.totalRows = 0;
      }

      if (this.totalRows === 0) {
        this.headVariant = "empty";
      } else {
        this.headVariant = "item";
      }
    }
  }

  @Watch("sessionAlreadyReviewed")
  private onSessionAlreadyReviewed() {
    if (this.reviewType === ReviewType.AlreadyReviewed) {
      this.isLoading = false;
      this.sessionList = this.sessionAlreadyReviewed;
      if (this.sessionAlreadyReviewed) {
        this.totalRows = this.sessionAlreadyReviewed.length;
      } else {
        this.totalRows = 0;
      }

      if (this.totalRows === 0) {
        this.headVariant = "empty";
      } else {
        this.headVariant = "item";
      }
    }
  }

  private created() {
    this.restoreTableState();
    this.configData();
    this.fetchData();
  }

  private configData() {
    if (this.reviewType === ReviewType.ReviewRequired) {
      this.title = "Review Required";
      this.reviewColumn = "Review";
      this.fields = [
        {
          key: "userName",
          label: "Name",
          sortable: true
        },
        {
          key: "title",
          label: "Recording",
          sortable: true
        },
        {
          key: "submittedOn",
          label: "Submitted On",
          sortable: true
        },
        {
          key: "review",
          label: "",
          sortable: false
        }
      ];
      if (
        this.sessionReviewRequired != null &&
        this.sessionReviewRequired.length > 0
      ) {
        this.onSessionReviewRequired();
      }
    } else if (this.reviewType === ReviewType.AlreadyReviewed) {
      this.fields = [
        {
          key: "userName",
          label: "Name",
          sortable: true
        },
        {
          key: "title",
          label: "Recording",
          sortable: true
        },
        {
          key: "reviewedOn",
          label: "Review Completed",
          sortable: true
        },
        {
          key: "review",
          label: "",
          sortable: false
        }
      ];
      this.title = "Review Completed";
      this.reviewColumn = "View";
      if (
        this.sessionAlreadyReviewed != null &&
        this.sessionAlreadyReviewed.length > 0
      ) {
        this.onSessionAlreadyReviewed();
      }
    }
  }

  @Watch("currentTeamID")
  private onCurrentTeamIdChanged(newVal: string, oldVal: string) {
    if (newVal && newVal !== oldVal) {
      this.isLoading = true;
      this.filter = null;
      this.currentPage = 1;
      this.fetchData();
    }
  }

  @Watch("sortBy")
  @Watch("sortDesc")
  @Watch("currentPage")
  private onTableStateChanged() {
    this.persistTableState();
  }

  private fetchData() {
    if (this.reviewType === ReviewType.ReviewRequired) {
      this.fetchReviewRequired();
    } else if (this.reviewType === ReviewType.AlreadyReviewed) {
      this.fetchAlreadyReviewed();
    }
  }

  private get tableStateKey() {
    return `orai-review-table:${this.currentTeamID || "team"}:${this.reviewType}`;
  }

  private restoreTableState() {
    const rawState = window.sessionStorage.getItem(this.tableStateKey);
    if (!rawState) {
      return;
    }

    try {
      const state = JSON.parse(rawState);
      this.sortBy = typeof state.sortBy === "string" ? state.sortBy : "";
      this.sortDesc = typeof state.sortDesc === "boolean" ? state.sortDesc : true;
      this.currentPage = typeof state.currentPage === "number" ? state.currentPage : 1;
    } catch (error) {
      window.sessionStorage.removeItem(this.tableStateKey);
    }
  }

  private persistTableState() {
    window.sessionStorage.setItem(
      this.tableStateKey,
      JSON.stringify({
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        currentPage: this.currentPage
      })
    );
  }
}
